import sabAPI from '@/api/sab'

const state = {
  signedUp: false,
  facebookEmail: null,
  authenticated: false,
  loading: true,
  loaded: false
}

const getters = {}

async function tryAuthenticate(commit, body, shouldThrow) {
  commit('SET_LOADING', true)

  try {
    await body()
    commit('SET_AUTHENTICATED', true)
    commit('SET_LOADING', false)
  } catch (err) {
    commit('SET_AUTHENTICATED', false)
    commit('SET_LOADING', false)

    if (shouldThrow) {
      throw err
    }
  }
}

const actions = {
  async signIn({ commit }, { credentials }) {
    await tryAuthenticate(commit, async () => sabAPI.signIn(credentials), true)
  },
  async signInWithPhone({ commit }, { credentials }) {
    await tryAuthenticate(commit, async () => sabAPI.signInWithPhone(credentials), true)
  },
  /** Tokens were stored by SAB (e.g. phone flow without PIN); sync Vuex session. */
  establishSessionFromTokens({ commit }) {
    commit('SET_LOADING', false)
    commit('SET_AUTHENTICATED', true)
  },
  signUp({ commit }, { credentials, extraData, recaptchaToken, authenticationPlatform, privacyPreferences }) {
    return sabAPI.signUp(credentials, extraData, authenticationPlatform, recaptchaToken, privacyPreferences).then(() => {
      commit('SET_SIGNED_UP', true)
    })
  },
  async refreshToken({ commit }) {
    const hasRefresh =
      typeof localStorage !== 'undefined' && localStorage.getItem('refreshToken')
    if (!hasRefresh) {
      // Do not call `tryAuthenticate` with a no-op refresh — that used to resolve "success" and
      // incorrectly set `authenticated: true` with no session. HE / first paint often has no token yet.
      commit('SET_AUTHENTICATED', false)
      commit('SET_LOADING', false)
      commit('SET_LOADED', true)
      return
    }
    await tryAuthenticate(commit, async () => sabAPI.refreshToken(), false)
    commit('SET_LOADED', true)
  },
  async signOut({ dispatch, commit }) {
    try {
      await sabAPI.signOut()
    } catch {
      // Server logout can fail offline; still clear the client session below.
    }
    if (typeof localStorage !== 'undefined') {
      localStorage.removeItem('accessToken')
      localStorage.removeItem('refreshToken')
    }
    commit('SET_SIGNED_UP', false)
    commit('SET_AUTHENTICATED', false)
    dispatch('user/unset', {}, { root: true })
    const { clearViuHeSessionMarkers, VIU_POST_LOGIN_PATH_KEY } = await import('@/js/viuHeaderEnrichment')
    clearViuHeSessionMarkers()
    if (typeof sessionStorage !== 'undefined') {
      sessionStorage.removeItem(VIU_POST_LOGIN_PATH_KEY)
    }
  }
}

const mutations = {
  SET_LOADING(state, loading) {
    state.loading = loading
  },
  SET_LOADED(state, loaded) {
    state.loaded = loaded
  },
  SET_AUTHENTICATED(state, authenticated) {
    state.authenticated = authenticated
  },
  SET_FACEBOOK_EMAIL(state, email) {
    state.facebookEmail = email
  },
  SET_SIGNED_UP(state, signedUp) {
    state.signedUp = signedUp
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
